import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import * as actionLayer from '../../modules/CustomerCareActions';
import UnlockCustomerCarePopup from './UnlockCustomerCarePopup';

const mapDispatchToProps = (dispatch) => ({
	unlockCustomerCare: (item) => dispatch(actionLayer.unlockCustomerCareUser.request(item)),
	goPopup: (popup) => dispatch(goPopup(popup)),
	closeModal: () => dispatch(goPopup('')),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	isLoading: nullSafe(() => state.CustomerCare.isLoading, false),
	payload: nullSafe(() => portalModalSelector(state).data.payload, {}),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(UnlockCustomerCarePopup);
